import angular from 'angular';
import uiRouter from 'angular-ui-router';
import operationComponent from './operation.component';
import operationProcedureComponent from './operation-procedure/operation-procedure.component';

let operationModule = angular
  .module('operation', [uiRouter])
  .config($stateProvider => {
    'ngInject';
    $stateProvider
      .state('newOperation', {
        url: '/operations/new',
        component: 'operation',
        parent: 'main',
        data: {
          permissions: {
            only: ['AUTHORIZED'],
            redirectTo: 'home'
          }
        },
        resolve: {
          operationTypes: OperationTypesService =>
            OperationTypesService.find({
              include: ['statesTemplates']
            })
        }
      })
      .state('editOperation', {
        url: '/operations/:id?:openOperationProcedureId&:openProcedures',
        component: 'operation',
        parent: 'main',
        data: {
          permissions: {
            only: ['AUTHORIZED'],
            redirectTo: 'home'
          }
        },
        resolve: {
          operation: (OperationsService, $stateParams) => {
            return OperationsService.findOne({
              filter: {
                where: {
                  id: $stateParams.id
                },
                include: [
                  'operationType',
                  'client',
                  'holder',
                  'vehicle',
                  'agency',
                  'creditor',
                  'createdByUser',
                  'updatedByUser',
                  {
                    relation: 'operationComments',
                    scope: {
                      order: 'createdAt DESC',
                      include: ['createdByUser']
                    }
                  },
                  {
                    relation: 'operationProcedures',
                    scope: {
                      include: [
                        {
                          relation: 'operationProcedureHistories',
                          scope: {
                            include: ['createdByUser', 'updatedByUser'],
                            order: 'createdAt ASC'
                          }
                        },
                        'tasks',
                        'currentTask'
                      ]
                    }
                  }
                ],
                deleted: true
              }
            });
          },
          operationTypes: OperationTypesService =>
            OperationTypesService.find({
              include: ['statesTemplates']
            }),
          statesTemplates: StatesTemplatesService =>
            StatesTemplatesService.find()
        }
      });
  })
  .component('operation', operationComponent)
  .component('operationOp', operationProcedureComponent).name;

export default operationModule;
